const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Chart / API month keys `YYYY-MM` → display like `Feb 26`. */
export function formatMonthYearCategory(value) {
  if (value == null || value === '') return value;
  const str = String(value);
  const m = str.match(/^(\d{4})-(\d{1,2})$/);
  if (!m) return str;
  const y = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10) - 1;
  if (Number.isNaN(y) || mo < 0 || mo > 11) return str;
  const yy = String(y).slice(-2);
  return `${MONTH_SHORT[mo]} ${yy}`;
}

export const formatDate = (dateString) => {
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    };

    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', options).format(date);
};

export function formatDateShort(isoString) {
    const date = new Date(isoString);
    return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
}

export function dateNow() {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0"); // Ensure two digits
    const month = now.toLocaleString("en-US", { month: "short" }); // Get short month name
    const year = now.getFullYear();
    
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    
    hours = hours % 12 || 12; // Convert to 12-hour format, ensuring 12 instead of 0
    
    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}
export function getCurrentDateTime() {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${hours}${minutes}${seconds}`;
}